import { AccountState } from '../../types';

const accountState: AccountState = {
  account: {
    address: '',
  },
};

export default accountState;
